module.exports = __webpack_public_path__ + "static/media/d.d58728bd.png";